/**
 * Avatar background identifiers used by the Weet AI generation pipeline.
 *
 * Values are persisted in generated speachs and passed via WeetInitiator to
 * speacher_front. DO NOT rename them.
 *
 * `TRANSPARENT` is legacy and kept for backward compatibility.
 */
export enum AIBackground {
    // Legacy
    TRANSPARENT = "TRANSPARENT",

    // Office
    OFFICE_1 = "OFFICE_1",
    OFFICE_2 = "OFFICE_2",
    OFFICE_3 = "OFFICE_3",
    OFFICE_4 = "OFFICE_4",
    OFFICE_5 = "OFFICE_5",
    OFFICE_6 = "OFFICE_6",
    OFFICE_7 = "OFFICE_7",
    OFFICE_8 = "OFFICE_8",
    OFFICE_9 = "OFFICE_9",
    OFFICE_10 = "OFFICE_10",
    OFFICE_11 = "OFFICE_11",
    OFFICE_12 = "OFFICE_12",
    OFFICE_13 = "OFFICE_13",

    // Room
    ROOM_1 = "ROOM_1",
    ROOM_2 = "ROOM_2",
    ROOM_3 = "ROOM_3",
    ROOM_4 = "ROOM_4",

    // Other themed
    WALL_1 = "WALL_1",
    WAREHOUSE_1 = "WAREHOUSE_1",
    INDUSTRIAL_1 = "INDUSTRIAL_1",
    INDUSTRIAL_2 = "INDUSTRIAL_2",
    INDUSTRIAL_3 = "INDUSTRIAL_3",

    // Solid colors
    WHITE = "WHITE",
    RED = "RED",
    YELLOW = "YELLOW",
    GREEN = "GREEN",
    BLUE = "BLUE",
    ORANGE = "ORANGE",
    PURPLE = "PURPLE",
    BLACK = "BLACK"
}
